import React from 'react';
import { islamicCalculators } from './ConstantsIslamicCalculator';
import SharedHelmet from '.././Helmet';
const TITLE = 'حواسب الزكاة - حواسب مجانية لحساب زكاة الأموال والأصول الشرعية';
const DESCRIPTION = 'استكشف مجموعة حواسب الزكاة المجانية، بما في ذلك حواسب حسابة زكاة المال والصدقات والأصول الشرعية وفقًا للقواعد الإسلامية.';
const KEYWORDS = 'حواسب الزكاة، حواسب مجانية، حاسبة زكاة المال، حاسبة زكاة الذهب، حاسبة زكاة الفضة، حاسبة زكاة الثمار، حاسبة زكاة عروض التجارة، حاسبة زكاة الحيوانات، حاسبة تحويل قراط الذهب';
const OG_URL = 'https://do-calculate.com/ar/zakat-calculators';
function CalculatorsList() {
    return (
        <div className="container rtl-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div  >
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-secondary" role="alert">
                    <p>{DESCRIPTION} </p>
                </div>
            </div>
            <hr/>
            <table >
                <thead>
                    <tr >
                        <th >الحاسبة</th>
                        <th >الوصف</th>
                    </tr>
                </thead>
                <tbody>
                    {islamicCalculators.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}
export default CalculatorsList;
